import React, { useEffect, useState } from "react";
import { getSortedItemGroups } from './HelperFunctions'

export const ProductSorting = ({ itemGroups, setItemGroups }) => {
    const [sortingID, setsortingID] = useState(() => {
        const storageSortingID = sessionStorage.getItem('sortingID');
        return storageSortingID ? parseInt(storageSortingID) : model.SortingModel.InitialSortingMethod;
    });

    useEffect(() => {
        model.itemGroupModel = getSortedItemGroups(model.itemGroupModel, sortingID);
        setItemGroups([...getSortedItemGroups(itemGroups, sortingID)]);
        sessionStorage.setItem('sortingID', sortingID);
    }, [sortingID]);


    if (itemGroups.length < 1) return <div className="md:tw-h-[30px]"></div>
    else {
        const sortingMethods = [];
        for (const method of model.SortingModel.SortingMethods) {
            sortingMethods.push(
                <div key={method.SortingID} className="tw-pb-[10px] md:tw-pb-[3px]"
                    style={(method.SortingID == sortingID) ? { fontWeight: "bold", color: "#A71635" } : {}}
                    onClick={(e) => { setsortingID(e.target.dataset['id']) }}
                    data-id={method.SortingID}>
                    {method.SortingName}
                </div >
            );
        }

        return (
            <div className="tw-text-[14px] tw-flex tw-justify-end tw-items-center tw-relative tw-flex-[1_0_50%]">
                <div className={"tw-content-center tw-text-right md:tw-static tw-top-[43px] " + (model.filterReponseInfo.TotalFiltersCount > 0 ? "tw-mt-[19px] tw-mb-[11px] md:tw-mt-0 md:tw-mb-0 md:tw-mr-[15px] tw-w-full tw-absolute" : "tw-mr-[15px]")}>
                    <span id="items-count">{itemGroups.length}</span><span id="items-count-label">{' item' + (itemGroups.length > 1 ? 's' : '')}</span>
                </div>

                <div className={"tw-relative tw-text-right tw-flex md:tw-gap-[10px] tw-text-mine-shaft-950 tw-items-center tw-justify-end md:tw-basis-auto " + (model.filterReponseInfo.TotalFiltersCount > 0 ? "tw-w-full" : "tw-w-[214px]")}>
                    <div className="tw-w-full md:tw-basis-auto tw-h-[43px] md:tw-h-[36px] md:tw-w-[214px] tw-flex tw-items-center tw-justify-around tw-cursor-pointer tw-pl-[10px] tw-pr-[9px]" style={{ border: "solid 1.5px #E0E0E0" }}
                        onClick={sortClick} onBlur={sortBlur} tabIndex="0">
                        <div className="tw-flex tw-text-left tw-w-full tw-mb-[2px] md:tw-mb-0">
                            <span className="tw-hidden md:tw-block">Sort By:&nbsp;</span><span id="method-name" className="tw-font-bold tw-text-[13.5px] sm:tw-text-[14px]">
                                {$("#sorting-menu").find(`[data-id='${sortingID}']`).text()}
                            </span>
                        </div>
                        <svg id="sort-svg" className="tw-w-[18px] tw-ml-[2px] tw-mr-[12px] md:tw-mr-0" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 612 792" style={{ enableBackground: "new 0 0 612 792", transition: "transform .2s" }} xmlSpace="preserve">
                            <g>
                                <rect x="157.3" y="198.5" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -225.0565 249.6209)" style={{ fill: "#A71D37" }} width="63" height="396" />
                                <rect x="226.2" y="365" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -156.1355 416.0993)" style={{ fill: "#A71D37" }} width="396" height="63" />
                            </g>
                        </svg>
                    </div>

                    <div id="sorting-menu" className="tw-absolute tw-text-[14px] md:tw-text-[16px] md:tw-text-[14px] tw-text-mine-shaft-1000 tw-top-[100%] tw-left-0 tw- md:tw-left-auto tw-w-full md:tw-w-[214px] tw-text-left tw-pl-[21px] md:tw-pl-[13px] tw-pt-[14px] tw-pb-[20px] md:tw-pb-[11px] tw-bg-white tw-z-10 tw-gap-[3px] tw-flex-col tw-cursor-pointer" style={{ border: "solid 1px #E0E0E0", boxShadow: "#00000029 0px 3px 6px", display: "none" }}>
                        {sortingMethods}
                    </div>
                </div>
            </div>
        );
    }

    function sortClick() {
        $("#sort-svg").toggleClass('spin-arrow');
        $("#sorting-menu").fadeToggle(270);
    }

    function sortBlur() {
        if ($("#sort-svg").hasClass('spin-arrow')) {
            $("#sort-svg").toggleClass('spin-arrow');
            $("#sorting-menu").fadeToggle(270);
        }
    }
}